import { getApiKey, getFlywireCode, uuidv4 } from 'services/common';
import { BASE_URL } from '../../config';
import { CheckoutRequest, CheckoutResponse } from "./types";
import * as Sentry from '@sentry/react';

export const checkout = async (
  data: CheckoutRequest,
  country: string,
  region: string,
  provider: string = 'FLY',
  hash: string = ''
  ): Promise<CheckoutResponse> => {
  const { token, ...cardlessData } = data.card || {};
  const requestForSentry:any = {
    ...data,
    card: cardlessData
  }
  try {
    const response = await fetch(`${BASE_URL}/api-payments/v1/payments/checkout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': getApiKey(region),
        'X-User': 'web',
        'X-Recipient-ID': getFlywireCode(country, region),
        'X-Request-ID': uuidv4(),
        'X-Payment-Gateway': provider
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json();
      Sentry.logger.error('checkoutService[checkout] error', { session: hash, request: requestForSentry, status: response.status, message: await response.text() });
      return {
        success: false,
        error: {
          message: `Failed to checkout: ${response.statusText}`,
          code: `${response.status}`,
          status: response.status,
          details: errorData,
        }
      };
    }
    Sentry.logger.info('checkoutService[checkout]', { session: hash, request: requestForSentry, response: {message: 'ok'} });
    return {
      success: true,
    };
  } catch (error) {
    Sentry.logger.error('checkoutService[checkout] unexpected error', { session: hash, request: requestForSentry, error: error });
    return {
      success: false,
      error: {
        message: `Unexpected error: ${error}`,
        code: 'NETWORK_ERROR'
      }
    };
  }
};